<template>
  <v-container>
    <v-card elevation="0" width="100%" height="100%">
      <v-card-title style="font-weight: bold; font-size: 24px; line-height: 32px; color: #333333;" v-if="!MobileSize">จัดการโปรโมชัน</v-card-title>
      <v-card-title class="px-0" style="font-weight: bold; font-size: 18px; line-height: 32px; color: #333333;" v-else>
        <v-icon color="#27AB9C" class="mr-2" @click="backtoMenu()">mdi-chevron-left</v-icon> จัดการโปรโมชัน
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6" class="">
            <v-text-field v-model="search" placeholder="ค้นหาโปรโมชัน" outlined dense hide-details>
              <v-icon slot="append" color="#27AB9C">mdi-magnify</v-icon>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row class="pt-2 pb-2">
          <v-col cols="12" md="9" sm="7">
            <span style="font-size: 16px; line-height: 24px; align-items: center; color: #333333; font-weight: 600" v-if="search !== ''">รายการโปรโมชันทั้งหมด {{ paginated.length }} รายการ</span>
            <span style="font-size: 16px; line-height: 24px; align-items: center; color: #333333; font-weight: 600" v-else>รายการโปรโมชันทั้งหมด {{ countList }} รายการ</span>
          </v-col>
          <v-col cols="12" md="3" sm="5" class="pt-0" align="right">
            <v-btn block dense :disabled="disableAddButton ? true : false" color="#27AB9C" class="white--text" @click="gotoCreate()">
              <v-icon>mdi-plus-circle-outline</v-icon>
              เพิ่มโปรโมชัน
            </v-btn>
          </v-col>
        </v-row>
        <!-- card -->
        <v-row no-gutters class="mt-4" v-if="paginated.length !== 0">
          <v-col cols="12" md="4" sm="6" class="pb-2" v-for="(item, index) in paginated" :key="index">
            <v-card :width="MobileSize ? '' : '300px'" height="100%" outlined style="padding-bottom: 50px;" class="mx-auto">
              <v-card-text :class="IpadSize ? 'pa-1 mb-8' : 'mb-4'">
                <v-row dense>
                  <v-col cols="12" md="6" sm="12" :align="IpadSize ? 'center' : 'start'" class="mt-2">
                    <v-chip v-if="item.have_limit === 'y' && item.is_expired === 'yes'" small :class="IpadSize ? 'px-14' : ''">โปรโมชันหมดอายุ</v-chip>
                    <v-chip v-else-if="item.have_limit === 'y' && item.is_expired === 'no' && item.limit_amount - item.use_count === 0" small :class="IpadSize ? 'px-16' : ''">โปรโมชันหมด</v-chip>
                    <v-chip v-else-if="item.have_limit === 'n' && item.is_expired === 'yes'" small :class="IpadSize ? 'px-14' : ''">โปรโมชันหมดอายุ</v-chip>
                  </v-col>
                  <v-col cols="12" md="6" sm="12" :align="IpadSize ? 'center' : 'end'">
                    <v-tooltip top color="#27AB9C" v-if="!dialigDetail || !MobileSize || !IpadSize || IpadProSize">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" :elevation="0" icon color="#F3F5F7" style="background-color: rgb(243, 245, 247);" class="mr-1" @click="showDetail(item)">
                          <v-icon color="#27AB9C" small>mdi-file-document-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>ดูรายละเอียด</span>
                    </v-tooltip>
                    <v-btn v-else v-bind="attrs" v-on="on" :elevation="0" icon color="#F3F5F7" style="background-color: rgb(243, 245, 247);" class="mr-1" @click="showDetail(item)">
                      <v-icon color="#27AB9C" small>mdi-file-document-outline</v-icon>
                    </v-btn>
                    <v-tooltip top color="#27AB9C" v-if="item.is_expired === 'no'">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" :elevation="0" icon style="background-color: rgb(243, 245, 247);" color="#F3F5F7" class="mr-1" @click="gotoEdit(item.id)">
                          <v-icon color="#27AB9C" small>mdi-pencil-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>แก้ไข</span>
                    </v-tooltip>
                    <v-tooltip top color="#27AB9C" v-if="!dialogConfirmDelete || !MobileSize || !IpadSize || IpadProSize">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" :elevation="0" icon style="background-color: rgb(243, 245, 247);" color="#F3F5F7" class="" @click="confirmDelete(item)">
                          <v-icon color="#27AB9C" small>mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>ลบ</span>
                    </v-tooltip>
                    <v-btn v-else v-bind="attrs" v-on="on" :elevation="0" icon style="background-color: rgb(243, 245, 247);" color="#F3F5F7" class="" @click="confirmDelete(item)">
                      <v-icon color="#27AB9C" small>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row dense justify="center" :class="IpadSize ? 'pa-2' : 'mt-2 pa-2'">
                  <v-card width="100%" height="250px" style="border-radius: 8px;" :elevation="0">
                    <v-img width="100%" height="250px" :src="item.promotion_logo" v-if="item.promotion_logo !== ''"></v-img>
                    <v-img width="250px" height="250px" src="@/assets/NoImage.png" v-else contain></v-img>
                  </v-card>
                </v-row>
                <v-row dense>
                  <v-col cols="12" md="12" class="font18">{{item.promotion_name}}</v-col>
                  <v-col cols="12" md="12" class="font14_500">{{item.promotion_type === 'free' ? 'ซื้อ X ชิ้น แถม Y ชิ้น' : item.promotion_type}}</v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row dense class="mb-4">
                  <v-col cols="1" md="1"><v-icon color="#27AB9C" small>mdi-clock-outline</v-icon></v-col>
                  <v-col cols="11" md="11" class="font10 mt-1">ระยะเวลาใช้โปรโมชัน :
                    <span v-if="item.start_date !== null">{{ new Date(item.start_date).toLocaleDateString('th-TH', { timeZone: 'UTC', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' }) }}</span>
                    <!-- <span v-if="item.have_timelimit === 'y' && new Date().toLocaleDateString('th-TH') === new Date(item.start_date).toLocaleDateString('th-TH')"> วันนี้ </span> -->
                    <!-- <span v-else> {{ new Date().toLocaleDateString('th-TH', {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' }) }} </span> -->
                    <span v-else> {{ new Date(item.created_at).toLocaleDateString('th-TH', { timeZone: 'UTC', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' }) }} </span>
                    -
                    <span v-if="item.end_date !== null">{{ new Date(item.end_date).toLocaleDateString('th-TH', { timeZone: 'UTC', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' }) }}</span>
                    <span v-else> ไม่มีสิ้นสุด </span>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions style="position: absolute; bottom: 0; width: 100%;">
                <v-card height="88px" width="100%" color="#D8EFE4" :elevation="0">
                  <v-row dense class="mt-2 font18_400">
                    <v-col cols="6" class="mt-2" align="center">ใช้แล้ว <br/>
                      <p style="color: #FF7C9C">{{item.use_count}}</p>
                    </v-col>
                    <v-divider vertical />
                    <v-col cols="6" class="mt-2" align="center">เหลืออยู่ <br/>
                      <p style="color: #42B971">{{item.have_limit === 'n' ? '-' : item.limit_amount - item.use_count}}</p>
                      <!-- <p style="color: #42B971">{{item.limit_amount === 0 ? '-' : item.limit_amount - item.use_count}}</p> -->
                    </v-col>
                  </v-row>
                </v-card>
              </v-card-actions>
            </v-card>
            <!-- <v-card min-height="88px">
            </v-card> -->
          </v-col>
        </v-row>
        <v-row v-if="paginated.length !== 0" no-gutters :justify="MobileSize ? 'center' : 'end'" class="my-6">
          <v-pagination color="#27AB9C" v-model="pageNumber" :length="pageCount" :total-visible="MobileSize ? '4' : '7'"></v-pagination>
        </v-row>
        <!-- empty data -->
        <v-row v-else>
          <v-col cols="12">
            <v-row justify="center" align-content="center">
              <v-col cols="12" md="12" align="center">
                <div class="my-5">
                  <v-img src="@/assets/Gracz/Customer/emptyGroupCustomer.png" max-height="500px" max-width="500px" height="100%" width="100%" contain aspect-ratio="2"></v-img>
                </div>
                <h2 style="padding-top: 20px; padding-bottom: 50px; color: #27AB9C;"><b>คุณยังไม่มีโปรโมชัน</b></h2>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>

      <!-- dialig detail -->
      <v-dialog max-width="426px" v-model="dialigDetail" :style="{'z-index': MobileSize ? '100': ''}">
        <v-card align="center" class="rounded-lg">
          <v-toolbar color="#BDE7D9" dark dense elevation="0">
            <span class="flex text-center ml-5" style="font-size:20px; color:#27AB9C;">ข้อมูลโปรโมชัน</span>
            <v-btn icon dark @click="dialigDetail = false, promotionDetail = []">
              <v-icon color="#27AB9C">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <br/>
          <v-card-text>
            <v-card width="250px" height="250px" style="border-radius: 8px;" class="ma-2" elevation="0">
              <v-img width="250px" height="250px" :src="this.promotionDetail.promotion_logo" v-if="this.promotionDetail.promotion_logo !== ''"></v-img>
              <v-img width="250px" height="250px" src="@/assets/NoImage.png" v-else></v-img>
            </v-card>
            <v-card outlined rounded align="left" class="pa-4 mt-4 pb-0">
              <p class="font16">ข้อมูลโปรโมชัน</p>
              <p class="font14">ประเภทโปรโมชัน : {{this.promotionDetail.promotion_type === 'free' ? 'ซื้อ X ชิ้น แถม Y ชิ้น' : this.promotionDetail.promotion_type}}</p>
              <p class="font14">ชื่อโปรโมชัน : {{this.promotionDetail.promotion_name}}</p>
              <p class="font14">ซื้อ: {{this.promotionDetail.minimum_amount}}</p>
              <p class="font14">แถม: {{this.promotionDetail.minimum_free}}</p>
            </v-card>
            <v-card outlined rounded align="left" class="pa-4 mt-4">
              <p class="font16">กำหนดระยะเวลาใช้โปรโมชัน</p>
              <span class="font14">ระยะเวลาใช้งาน : </span>
              <span v-if="this.promotionDetail.start_date !== null">{{ new Date(this.promotionDetail.start_date).toLocaleDateString('th-TH', { timeZone: 'UTC', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' }) }}</span>
              <!-- <span v-if="this.promotionDetail.have_timelimit === 'y' && new Date().toLocaleDateString('th-TH') === new Date(this.promotionDetail.start_date).toLocaleDateString('th-TH')"> วันนี้ </span> -->
              <span v-else> {{ new Date(this.promotionDetail.created_at).toLocaleDateString('th-TH', { timeZone: 'UTC', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' }) }} </span>
              -
              <span v-if="this.promotionDetail.end_date !== null">{{ new Date(this.promotionDetail.end_date).toLocaleDateString('th-TH', { timeZone: 'UTC', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' }) }}</span>
              <span v-else> ไม่มีสิ้นสุด </span>
            </v-card>
            <v-card outlined rounded align="left" class="pa-4 mt-4 pb-0">
              <p class="font16">กำหนดจำนวนและสิทธิ์</p>
              <p class="font14">จำนวนที่ใช้ได้ : {{this.promotionDetail.limit_amount === 0 ? 'ไม่กำหนด' : this.promotionDetail.limit_amount}}</p>
              <p class="font14">สิทธิ์ในการใช้ : {{this.promotionDetail.access_amount === 0 ? 'ไม่จำกัด' : this.promotionDetail.access_amount}}</p>
            </v-card>
            <v-card outlined rounded align="left" class="pa-4 mt-4">
              <p class="font16">กลุ่มลูกค้าที่สามารถใช้โปรโมชันได้</p>
              <v-row>
                <v-col cols="4" class="font14 py-2 ma-0" v-for="(item, index) in this.promotionDetail.group_channel_json" :key="index">
                  <v-tooltip top color="#27AB9C" v-if="item.name.length > 8">
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip v-bind="attrs" v-on="on" style="width: 100px; justify-content: center;" color="#ebf6f1" text-color="#27AB9C">{{item.name.length > 8 ? item.name.substring(0, 10) + '...' : item.name}}</v-chip>
                    </template>
                    <span v-if="item.name.length > 8">{{item.name}}</span>
                  </v-tooltip>
                  <v-chip v-else v-bind="attrs" v-on="on" style="width: 100px; justify-content: center;" color="#ebf6f1" text-color="#27AB9C">{{item.name}}</v-chip>
                </v-col>
              </v-row>
                <!-- <v-chip class="" color="#FFCB05" text-color="#FFFFFF" v-if="item.id === 1">{{item.name}}</v-chip>
                <v-chip class="" color="#9B9D9F" text-color="#FFFFFF" v-if="item.id === 2">{{item.name}}</v-chip>
                <v-chip class="" color="#27AB9C" text-color="#FFFFFF" v-if="item.id !== 1 && item.id !== 2">{{item.name}}</v-chip> -->
            </v-card>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- dialog comfirm Delete -->
      <v-dialog max-width="464px"  v-model="dialogConfirmDelete" persistent>
        <v-card max-height="300px" align="center" class="rounded-lg">
          <v-toolbar color="#BDE7D9" dark dense elevation="0">
            <span class="flex text-center ml-5" style="font-size:20px"><font color="#27AB9C">ลบโปรโมชัน</font></span>
            <v-btn icon dark @click="dialogConfirmDelete = false, promotionDetail = []">
              <v-icon color="#27AB9C">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <br/>
          <v-card-text class="mt-10 mb-4">
            <span style="font-weight: 400; font-size: 14px; line-height: 22px; color: #333333;">คุณลบโปรโมชัน {{promotionDetail.promotion_name}}</span>
            <br/>
            <span style="font-weight: 400; font-size: 14px; line-height: 22px; color: #333333;">คุณต้องการทำรายการนี้ ใช่หรือไม่ ?</span>
          </v-card-text>
          <v-card-actions >
        <v-row justify="center" dense class="mb-4">
          <v-btn dense  dark outlined color="#27AB9C" class="pl-7 pr-7 mt-2" @click="dialogConfirmDelete = false, promotionDetail = []">ยกเลิก</v-btn>
          <v-btn dense  color="#27AB9C" class="ml-4 mt-2 pl-8 pr-8 white--text" @click="deletePromotion()">ตกลง</v-btn>
        </v-row>
        </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- dialog Success -->
      <v-dialog v-model="dialogSuccess" width="373" persistent>
        <v-card style="background: #FFFFFF; border-radius: 4px;" min-height="246px">
          <v-toolbar align="center" color="#BDE7D9" dark dense elevation="0">
            <span class="flex text-center ml-5" style="font-size:20px">
              <font color="#27AB9C" v-if="status === 'create'">เพิ่มหมวดหมู่สินค้า</font>
              <font color="#27AB9C" v-if="status === 'edit'">เพิ่มหมวดหมู่สินค้า</font>
              <font color="#27AB9C" v-if="status === 'delete'">ลบโปรโมชัน</font>
            </span>
            <v-btn icon dark @click="dialogSuccess = false, status = ''">
              <v-icon color="#27AB9C">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-container>
            <v-card-text>
              <v-row justify="center" no-gutters dense>
                <v-col cols="12" align="center">
                  <v-img src="@/assets/ImageINET-Marketplace/ICONShop/successIcon.png" contain max-height="70" max-width="70"></v-img>
                </v-col>
                <v-col cols="12" align="center" class="mt-6">
                  <p style="font-weight: 500; font-size: 14px; line-height: 22px; color: color: #333333;" class="pt-0 mt-0">เสร็จสิ้น</p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-container>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>

<script>
import { Decode } from '@/services'
export default {
  data () {
    return {
      userDetailSelling: [],
      seller_shop_id: '',

      disableAddButton: false,
      search: '',
      countList: 0,
      promotionList: [],
      pageCount: 0,
      itemPerPage: 9,
      current: 1,

      // dialigDetail
      dialigDetail: false,
      promotionDetail: [],

      status: '',
      // dialogdelete
      dialogConfirmDelete: false,
      dialogSuccess: false
    }
  },
  watch: {
    MobileSize (val) {
      if (val === true) {
        this.$router.push('/Order/PromotionMobile').catch(() => {})
      } else {
        this.$router.push('/Order/Promotion').catch(() => {})
      }
    }
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    },
    pageNumber: {
      get () {
        return this.current || 1
      },
      set (newPage) {
        // You could alternatively call your API here if you have serverside pagination
        this.current = newPage
        window.scrollTo(0, 0)
      }
    },
    indexStart () {
      return (this.current - 1) * this.itemPerPage
    },
    indexEnd () {
      return this.indexStart + this.itemPerPage
    },
    paginated () {
      if (this.search === '') {
        return this.promotionList.slice(this.indexStart, this.indexEnd)
      } else {
        return this.promotionList.filter(promotionList => {
          return promotionList.promotion_name.toLowerCase().includes(this.search.toLowerCase())
        })
      }
    }

  },
  mounted () {
    window.scrollTo(0, 0)
  },
  created () {
    // this.$EventBus.$emit('changeNav')
    if (localStorage.getItem('oneData') === null) {
      this.$router.push({ path: '/' }).catch(() => {})
    } else {
      if (localStorage.getItem('UserDetailSelling') !== null) {
        this.userDetailSelling = JSON.parse(Decode.decode(localStorage.getItem('UserDetailSelling')))
        this.seller_shop_id = this.userDetailSelling.seller_shop_id
      }
      this.getData()
    }
  },
  methods: {
    backtoMenu () {
      if (this.MobileSize) {
        this.$router.push({ path: '/Order/SellerShopMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/SellerShop' }).catch(() => {})
      }
    },
    gotoCreate () {
      if (this.MobileSize) {
        this.$router.push({ path: `/Order/ManagePromotionMobile?Status=create&ShopID=${this.seller_shop_id}` }).catch(() => {})
      } else {
        this.$router.push({ path: `/Order/ManagePromotion?Status=create&ShopID=${this.seller_shop_id}` }).catch(() => {})
      }
    },
    gotoEdit (PromotionID) {
      if (this.MobileSize) {
        this.$router.push({ path: `/Order/ManagePromotionMobile?PromotionID=${PromotionID}&Status=edit&ShopID=${this.seller_shop_id}` }).catch(() => {})
      } else {
        this.$router.push({ path: `/Order/ManagePromotion?PromotionID=${PromotionID}&Status=edit&ShopID=${this.seller_shop_id}` }).catch(() => {})
      }
    },
    getErrMsg (msg) {
      if (msg === 'This user is unauthorized.') {
        return 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง'
      } else if (msg === '') {
        return 'ระบบขัดข้อง กรุณาติดต่อเจ้าหน้าที่'
      }
    },
    getTime () {
      return (new Date()).getTime() + Math.round(Math.random())
    },
    async getData () {
      this.$store.commit('openLoader')
      var data = {
        seller_shop_id: this.seller_shop_id
      }
      await this.$store.dispatch('actionsGraczListPromotion', data)
      var res = await this.$store.state.ModuleGraczPromotionJS.stateGraczListPromotion
      // var res = { result: 'SUCCESS' }
      if (res.result === 'success') {
        this.promotionList = res.data.promotion
        this.promotionList.forEach(element => {
          element.promotion_logo = element.promotion_logo + '?nochace=' + this.getTime()
        })
        this.countList = res.data.count_promotion
        this.pageCount = parseInt(this.countList / this.itemPerPage) === 0 ? 1 : Math.ceil(this.countList / this.itemPerPage)
        this.$store.commit('closeLoader')
      } else {
        this.$store.commit('closeLoader')
        if (res.message === 'Not access this function.') {
          await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var msg
          if (res.result === 'error') {
            msg = this.getErrMsg(res.message)
            this.$swal.fire({ icon: 'error', text: msg, showConfirmButton: false, timer: 1500 })
          } else {
            msg = this.getErrMsg('')
            console.log(msg)
            this.$swal.fire({ icon: 'error', text: msg, showConfirmButton: false, timer: 1500 })
          }
        }
      }
      console.log('data to API search', data)
      // console.log('res from API search', res)
    },
    // dialog detail
    showDetail (item) {
      this.promotionDetail = item
      this.dialigDetail = true
    },
    // dialog delete
    confirmDelete (item) {
      this.status = 'delete'
      this.promotionDetail = item
      this.dialogConfirmDelete = true
    },
    async deletePromotion () {
      this.$store.commit('openLoader')
      this.dialogConfirmDelete = false
      var data = {
        seller_shop_id: this.seller_shop_id,
        promotion_id: this.promotionDetail.id
      }
      await this.$store.dispatch('actionsGraczDeletePromotion', data)
      var res = await this.$store.state.ModuleGraczPromotionJS.stateGraczDeletePromotion
      // var res = { result: 'SUCCESS', message: 'hello' }
      if (res.result === 'success') {
        this.$store.commit('closeLoader')
        this.getData()
        this.dialogSuccess = true
        setTimeout(() => { this.dialogSuccess = false }, 1500)
        window.scrollTo(0, 0)
      } else {
        this.$store.commit('closeLoader')
        if (res.message === 'Not access this function.') {
          await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var msg
          if (res.result === 'error') {
            msg = this.getErrMsg(res.message)
            this.$swal.fire({ icon: 'error', text: msg, showConfirmButton: false, timer: 1500 })
          } else {
            msg = this.getErrMsg('')
            console.log(msg)
            this.$swal.fire({ icon: 'error', text: msg, showConfirmButton: false, timer: 1500 })
          }
        }
      }
      console.log('res from API Delete', res)
      console.log('data to API Delete', data)
    }
  }
}
</script>
<style scoped>
.font10 {
  font-size: 10px; font-weight: 500;  line-height: 14px; color: #9A9A9A;
}
.font14 {
  font-size: 14px; font-weight: 400; line-height: 22px; color: #333333;
}
.font14_500 {
  font-size: 14px; font-weight: 500; line-height: 22px; color: #9A9A9A;
}
.font16 {
  font-size: 16px; font-weight: 700; line-height: 24px; color: #27AB9C;
}
.font18_400 {
  font-size: 18px; font-weight: 400; line-height: 24px; color: #333333;
}
.font18 {
  font-size: 18px; font-weight: 700; line-height: 24px; color: #333333;
}

</style>
